//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Object.js";
import "../MechanicalRouting/MechanicalRouting.RoutingManager.js";
let d=[[],[[["part"],"RefreshSpools",{},1,0],[["members"],"RemoveMembersFromTheirSpools",{},1,0],[["members","desinationSpool"],"MoveMembersToSpool",{},2,0],[["part"],"IsSpoolAssembly",{R_:{isSpoolAssembly:''}},1,0],[["spoolAssemblyPart"],"FindSourceSpool",{R_:{sourceSpool:"MechanicalRouting.Spool"}},1,0],[["spoolAssemblyPart"],"FindParentAssembly",{R_:{parentAssemblyPart:"Part"}},1,0],[["spoolAssemblyComponent","sourceSpool"],"FindParentAssemblyComponent",{R_:{parentAssemblyComponent:"Assemblies.Component"}},2,0],[["spools","numberOfSpoolAssemblies"],"QuerySpoolAssemblies",{R_:{spoolAssemblyFileNames:""}},1,0],[["spoolAssembly"],"QueryParentAssembly",{R_:{parentFileName:''}},1,0],[["spools"],"RefreshSpoolAssemblyInformation",{},1,0]],[]];
SPLM.MechanicalRouting.SpoolManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.MechanicalRouting.SpoolManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;